import { useState, useEffect } from "react";
import { Button, Grid, FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import PostAddIcon from '@material-ui/icons/PostAdd'
import HeaderModal from "../../../global/headerModal";
import BackDrop from "./../../../global/BackDrop";
import ModalBase from "./../../../global/ModalBase";
import { FormularioPagoGrupalStyle } from "./ButtonPagoGrupalStyle";
import useApi from "./../../../hooks/useAPI";
import { ToastMessage } from "../../../global/ToastMessage";
import { useSelector, useDispatch } from "react-redux";
import { crearCompraItemGrupo, obtenerComprasPagarGrupo, obtenerGrupoAction } from "./../../../ducks/viajeCalendarioDuck"
import DetallePagoGrupo from "./DetallePagoGrupo";
import {  FormatoFechaIso } from '../../../utils/FormatFecha';
import { formatDinero } from "../../../utils/formatDinero";
import { DialogMessage } from "../../../global/DialogMessage";
const ModalFormulario = (props) => {
    const {
        open = true,
        setOpen = () => { }
    } = props;

    const { fecha, grupoDetail, ItemsPagarGrupo } = useSelector((store) => store.calendario);
    const dispatch = useDispatch()
    const dataTipoCompra = useApi("Catalog/CatPayGroup")
    const classes = FormularioPagoGrupalStyle()
    const [load, setLoad] = useState(false)
    const [tipoCompra, setTipoCompra] = useState(0)

    useEffect(() => {
        setLoad(true)
        dispatch(obtenerComprasPagarGrupo({ idTpoCompra: tipoCompra, fechaViaje:  FormatoFechaIso({date: grupoDetail?.FechaSalida, formato: "MMddyyyyHHmmss" }), nombrePaquete: grupoDetail?.NombrePaquete })).then(Response => {
            setLoad(false)
        })
    }, [dispatch, tipoCompra, grupoDetail?.FechaSalida, grupoDetail?.NombrePaquete ])

    const onSave = (values) => {
        setLoad(true)
        DialogMessage.fire({
            title: '¿Estas seguro que deseas realizar esta acción?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aceptar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(crearCompraItemGrupo({
                    nombrePaquete: grupoDetail?.NombrePaquete,
                    idTipoCompra: tipoCompra,
                    fechaViaje: FormatoFechaIso({date: grupoDetail?.FechaSalida, formato: "MMddyyyyHHmmss" })
                })).then(Response => {
                    switch (Response.status) {
                        case 500:
                            ToastMessage.fire({
                                icon: "error",
                                title: "Ha habido un problema con el servidor",
                            });
                            break;
                        case 400:
                            ToastMessage.fire({
                                icon: "warning",
                                title: "<strong>Atención</strong>",
                                text: "Al menos un dato no se ha enviado, favor de llenar el registro.",
                            });
                            break;
                        default:
                            dispatch(obtenerGrupoAction({ nombre: grupoDetail?.NombrePaquete }))
                            handleClose();
                            ToastMessage.fire({
                                icon: "success",
                                title: "Ingreso Correcto",
                            });
                            break;
                    }
                    setLoad(false)
                })
            }
        })
    }

    const handleClose = () => {
        setOpen(false)
        setLoad(false)
        setTipoCompra(0)
    }
    const handleSelecTipoCompra = (event) => {
        setTipoCompra(event.target.value)
    }
    return (
        <ModalBase classes={classes} open={open} onClose={handleClose}>
            <HeaderModal
                handleClose={handleClose}
                titulo="Pago grupal"
            />
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    Paquete: {grupoDetail?.NombrePaquete}
                </Grid>
                <Grid item xs={12} style={{ textAlign: "center" }}>
                    Fecha: {fecha}
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel id="lTipoCompra">Concepto</InputLabel>
                        <Select
                            labelId="lTipoCompra"
                            id="SlTipoCompra"
                            name="tipoCompra"
                            value={tipoCompra}
                            onChange={handleSelecTipoCompra}
                            label="Tipo Compra"
                        >
                            <MenuItem value="0" disabled>
                                {"Seleccione una opción"}
                            </MenuItem>
                            {dataTipoCompra.map((item, index) => (
                                <MenuItem key={item.idTipoCompra} value={item.idTipoCompra}>
                                    {item.Descripcion}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12}>
                    <div style={{textAlign: "center"}}>
                        <span>Resumen de pago: </span>
                        <DetallePagoGrupo />
                    </div>
                </Grid>
                <Grid item xs={12}>
                    <div style={{textAlign: "center"}} >
                    <p>Total a Pagar: {formatDinero(ItemsPagarGrupo.totalPagar)} {ItemsPagarGrupo.moneda?.Clave}</p>
                        <p>¿Esta seguro de mandar la solicitud de pago al area de finanzas?</p>
                    </div>
                </Grid>
            </Grid>
            <Grid container className={classes.containerSpacing}>
                <Grid item xs={12} className={classes.modalBotonesCenter}>
                    <Button
                        variant="contained"
                        color="primary"
                        className={classes.modalBoton}
                        onClick={onSave}
                    >
                        Guardar
                    </Button>
                </Grid>
            </Grid>
            <BackDrop open={load} />
        </ModalBase>
    )
}


const ButtonPagoGrupal = () => {
    const [open, setOpen] = useState(false)
    const onClick = () => {
        setOpen(true)
    }
    return (
        <div>
            <Button variant="outlined" color="primary" onClick={onClick} endIcon={<PostAddIcon />}>
                Pago grupal
            </Button>
            <ModalFormulario
                open={open}
                setOpen={setOpen}
            />
        </div>
    )
}
export default ButtonPagoGrupal